// MSAL 4 temporary/interaction cache keys (TemporaryCacheKeys) that must not leak from the popup into the tab.
const TEMPORARY_KEY_SUFFIXES = ["interaction.status", "urlHash", "code.verifier"];

/**
 * Keeps only the MSAL cache entries from the consent popup's sessionStorage hand-off.
 */
export function filterMsalCacheEntries(raw: Record<string, unknown>): Record<string, string> {
    const entries: Record<string, string> = {};
    for (const [key, value] of Object.entries(raw)) {
        if (typeof value !== "string" || !key.startsWith("msal.")) {
            continue;
        }
        if (key.includes(".request.") || TEMPORARY_KEY_SUFFIXES.some(suffix => key.endsWith(suffix))) {
            continue;
        }
        entries[key] = value;
    }
    return entries;
}
